import React from 'react';
import { withFormikFormControl } from '../FormikFormControl';
import { FormPageFieldComponentProps } from 'types/formPage';
import BaseInput from "./BaseFields/BaseInput";

export const SingleLineText = (props: FormPageFieldComponentProps) => {
  return <BaseInput {...props}/>
};

export const SingleLineTextFormik = withFormikFormControl()(SingleLineText);

export default React.memo(SingleLineTextFormik);
